export enum COMPANY_WINDOWS {
  InitialSupport,
  ClientCodeVerification,
  CreateChild,
  CreateNewHierarchy
}

export enum PAYLOAD_ID_KEYS {
  LogisticsJournalId = "logisticsJournalId",
  ParentCompanyId = "parentCompanyId"
}

export enum COMPANY_TYPE {
  NewHierarchy = "new hierarchy",
  Regular = "company"
}

export enum MOVE_COMPANY_KEYS {
  SourceCompany = "sourceCompany",
  TargetCompany = "targetCompany"
}

export enum MOVE_COMPANY_ERROR_MESSAGES {
  ExceedsLimit = "Moving here would exceed the maximum allowed company depth of 4 levels."
}
